/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'utils/moment';
import PulpoField from '../../../pulpo_visualizer/fields/PulpoField';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack/HeaderBack';
import Panel from '../../../components/panel/Panel';
import Button from '../../../components/button/button';
import Loading from '../../../components/loading/loading';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';
import WorkorderStyles from './workOrderCreate.module.scss';
import FixedFeilds from './FixedFeilds';
import { S3Uploads, GetFileName } from '../../services';
import { searchUser, fetchDataSourceList } from '../../inspections/redux/actions';
import { fetchCategories, fetchWorkOrderSchema, createLeaseWokrorder, clear,
  fetchLocations } from '../redux/actions';
import { fetchUserProfile } from '../../authentication/redux/actions';
import MultiColumnGrid from '../../forms/MultiColumnGrid';
import { handleMultiFieldErrorList } from '../../forms/utils/helpers';
import defaultFields from '../defaulf_fields.json';

class MaintenanceCreate extends Component {
  state = {
    info: {
      report_date: moment().format(),
      attachments: [],
      logged_by: {},
      subcategory: ''
    },
    answers: {},
    requiredMap: {},
    showFormErrors: false,
    fieldErrors: {
      logged_by: false,
      report_date: false,
      category_id: true,
      priority: false,
      problem_description: true,
      location: false,
      subcategory: true
    },
    loadingStatus: false,
    errorListMCG: {}
  }

  firstTime = true;

  componentDidMount() {
    const {
      actionFetchCategories,
      actionFetchSchema,
      fetchDataSources,
      actionfetchLocations,
      actionFetchProfile
    } = this.props;
    actionFetchProfile();
    actionFetchCategories();
    actionFetchSchema();
    actionfetchLocations();
    fetchDataSources();
    this.setState({ loadingStatus: true });
  }

  static getDerivedStateFromProps(props, state) {
    // grab user from state
    if (props.user.id && !state.info.logged_by.id) {
      return {
        ...state,
        info: {
          ...state.info,
          logged_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        }
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { leaseMaintenance_schema, user, fetchSchemaAction, createWorkorderAction, history } = this.props;
    if (this.firstTime && leaseMaintenance_schema.workorder && leaseMaintenance_schema.workorder.id) {
      this.processInspectionForState(leaseMaintenance_schema.workorder, user);
      this.firstTime = false;
    }
    if (prevProps?.fetchSchemaAction?.loading === true && fetchSchemaAction?.loading === false && fetchSchemaAction?.success === true) {
      this.handleLoadingStatus(false);
    }
    if (prevProps?.createWorkorderAction?.loading === true && createWorkorderAction?.loading === false && createWorkorderAction?.success === true) {
      this.handleLoadingStatus(false);
      history.push('/maintenance');
    }
  }

  componentWillUnmount() {
    const { actionClear } = this.props;
    actionClear();
  }

  handleLoadingStatus = (value) => {
    this.setState({ loadingStatus: value });
  }

  processInspectionForState = (workorder, user) => {
    if (workorder) {
      const { schema } = workorder;
      let { fieldErrors, requiredMap, answers } = this.state;

      schema.fields.forEach((f) => {
        requiredMap = { ...requiredMap,
          [f.id]: f.type === 'user_dropdown' ? false: f.required };
        fieldErrors = { ...fieldErrors,
          [f.id]: f.type === 'user_dropdown'? false: f.required };
        if (f.type === 'user_dropdown') {
          answers = { ...answers, [f.id]: ' ' };
        }
      });
      if (user?.portal_airport?.airport_settings?.enable_service_request === true) {
        fieldErrors.location = false;
      } else {
        fieldErrors.location = schema?.default_fields?.default_location?.required || false;
      }
      this.setState({ requiredMap, fieldErrors, answers });
    }
  }

  handleAnswerChanged = (section, answer, fieldId) => {
    const { locations, user, leaseMaintenance_schema } = this.props;
    let airfield_location = user.airport?.location?.coordinates ? user.airport.location.coordinates:'';
    const fieldType = leaseMaintenance_schema?.workorder?.schema?.fields.find(obj => obj.id === fieldId);
    if (fieldId === 'location' && section === 'info') {
      let location = { airfield_location: answer };
      if (typeof (answer) === 'string') {
        const get_location = locations?.custom_locations?.filter(loc => loc.name === answer);
        if (get_location.length > 0 && get_location[0].default_location) {
          airfield_location = get_location[0].default_location?.coordinates;
        }
        location = { airfield_location, location: answer };
      }
      this.setState(prevState => ({
        info: { ...prevState.info, ...location },
        locationChanged: true
      }));
    } else if (section === 'info' && fieldId === 'sub_location') {
      let location = { airfield_location: answer };
      if (typeof (answer) === 'string') {
        if (fieldId === 'location') {
          this.handleFieldErrorChanged(fieldId, !!(answer && answer === ''));
        }
        const get_location = locations?.sub_locations?.filter(loc => loc.name === answer);
        if (get_location.length > 0 && get_location[0].default_sub_location) {
          airfield_location = get_location[0].default_sub_location?.coordinates;
        }
        location = { airfield_location, sub_location: answer };
      }
      this.setState(prevState => ({
        info: { ...prevState.info, ...location },
        locationChanged: true
      }));
    } else {
      if (fieldType?.type === 'multi_field' && answer?.length > 0) {
        this.setState((prevState) => {
          const updatedErrorListMCG=handleMultiFieldErrorList(fieldType, answer, fieldId, prevState);
          return {
            errorListMCG: updatedErrorListMCG
          };
        });
      }
      if (fieldId === 'global_location') {
        this.handleFieldErrorChanged('location', !!(answer && answer === ''));
      }
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  }

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  }

  handleSearchForUser = (value) => {
    const { actionSearchUser } = this.props;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      actionSearchUser(value);
    }, 300);
  }

  create = async () => {
    const {
      actionCreate,
      user,
      allCategories
    } = this.props;

    const {
      info,
      fieldErrors,
      answers,
      errorListMCG
    } = this.state;

    if (info.priority) {
      fieldErrors.priority = false;
    } else {
      fieldErrors.priority = true;
    }
    if (info.subcategory === '' || info.subcategory === null || info.subcategory === undefined) {
      if (allCategories?.filter(e => Number(e.id) === Number(info?.category_id))[0]?.sub_categories.length === 0) {
        fieldErrors.subcategory = false;
      }
    }
    if (info.subcategory) {
      const sub = allCategories?.filter(e => Number(e.id) === Number(info?.category_id))[0]?.sub_categories;
      if (sub && Object.keys(sub).length !== 0
       && (sub.find(e => String(e) === String(info.subcategory)) === undefined || sub.find(e => String(e) === String(info.subcategory)) === null
        || sub.find(e => String(e) === String(info.subcategory)) === '')) {
        fieldErrors.subcategory = true;
      } else {
        fieldErrors.subcategory = false;
      }
    }
    const noErrors = Object.keys(fieldErrors)
      .every(k => (fieldErrors[k] === false));
    const errorMCGlist = Object.keys(errorListMCG).map(val => ({ [val]: errorListMCG[val] }));
    if (noErrors && errorMCGlist.length === 0) {
      this.setState({ loadingStatus: true });
      const data = { ...info };
      data.logged_by = data.logged_by.id;
      data.response = JSON.stringify(answers);
      if (data.global_location) {
        data.global_locations = JSON.stringify({ global_location: data.global_location });
        delete data.global_location;
      }
      if (data.airfield_location) {
        data.airfield_location = JSON.stringify({
          type: 'Point',
          coordinates: data.airfield_location
        });
      }
      if (data.locationImage) {
        data.locationImage = JSON.stringify(data.locationImage);
      }
      if (data.location_marked) {
        data.location_marked = JSON.stringify(data.location_marked);
      }
      data.tenant_id = user.current_tenant?.id || user.tenant[0].id;
      if (data.subcategory) {
        if (allCategories.filter(e => Number(e.id) === Number(info.category_id))[0]?.sub_categories?.length === 0) {
          data.subcategory = '';
        }
      }
      const formData = new FormData();
      Object.keys(data).forEach((k) => {
        if (k !== 'attachments') {
          formData.append(k, data[k]);
        }
      });
      let fileIds = '';
      if (data.attachments.length > 0) {
        fileIds = await this.getFileNames(data.attachments.length);
      }
      formData.append('email_date', moment().format());
      formData.append('source', 'Tenant Portal');
      if (fileIds) {
        await this.doS3Upload(data.attachments, fileIds, 'work_orders')
          .then(() => {
            fileIds.filename.forEach((id) => {
              formData.append('attachments', id.toString());
            });
            actionCreate(formData);
          });
      } else {
        actionCreate(formData);
      }
    } else {
      this.setState({ showFormErrors: true, loadingStatus: false });
    }
  }

  getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(files, fileIds.filename, entity);
    return response;
  };

  cancelWorkorderCreate = () => {
    this.props.history.push('/maintenance');
  }

  render() {
    const { userlist, translations, user, allCategories, allDataSources,
      leaseMaintenance_schema, allProperties, locations } = this.props;
    const { info, showFormErrors, requiredMap, answers, loadingStatus, locationChanged, errorListMCG } = this.state;
    const translationMap = translations ? translations[user.language] : {};
    const sortCategories = _.sortBy(allCategories, [eachCategory => eachCategory.order]);
    const maintenanceTitle = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : 'Maintenance Requests';
    const maintenanceButton = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : '';
    let default_fields = [];
    defaultFields.default_fields.forEach((eachDefaultField) => {
      default_fields.push(eachDefaultField?.id);
    });
    let fieldsCheck = (leaseMaintenance_schema?.workorder?.schema?.ordering?.length > 0
      ? leaseMaintenance_schema?.workorder?.schema?.ordering : default_fields);
    return (
    <>
      <SectionHeader icon={icon} translationID="topbar.Maintenance_Requests" defaultTitle={maintenanceTitle} values={{ maintenanceTitle }} />
      <HeaderBack
        translationID="inspections.new.prev"
        translationDefault="Back"
        backRoute={'/maintenance'}
      />
      {loadingStatus && (<Loading loadingStatus={loadingStatus} />)}
      <div className={`container ${WorkorderStyles.form} ${WorkorderStyles.customWidth}`}>
        <Panel title="maintenance.start.heading" defaultTitle={`Create ${maintenanceButton || 'Work Order'}`}>
            <div className={`${WorkorderStyles.content} ${WorkorderStyles.embedded}`}>
              {fieldsCheck?.map(eachfield => (
              <>
                {allCategories && (
                  <FixedFeilds
                    info={info}
                    translation={translationMap}
                    userlist={userlist}
                    allProperties={allProperties}
                    categories={sortCategories}
                    eachfield={eachfield}
                    leaseMaintenance_schema={leaseMaintenance_schema}
                    searchForUser={this.handleSearchForUser}
                    handleAnswerChanged={this.handleAnswerChanged}
                    handleFieldErrorChanged={this.handleFieldErrorChanged}
                    showFormErrors={showFormErrors}
                    global_locations={locations?.nawo_location?.length>0? locations?.nawo_location: locations?.locations}
                    locations={locations?.custom_locations}
                    sub_locations={locations?.sub_locations}
                    enable_locations_in_public
                    map_view={leaseMaintenance_schema?.settings?.map_view}
                    locationChanged={locationChanged}
                    changeLocationChangedStatus={() => { this.setState({ locationChanged: false }); }}
                    location_attachments={locations?.location_attachments}
                    defaultLocation={user?.portal_airport?.location?.coordinates}
                    map={{ map_style: user?.portal_airport?.airport_settings?.map_style,
                    mapbox_style: user?.portal_airport?.airport_settings?.mapboxz_style }}
                  />
                )}
                {Object.keys(requiredMap).length > 0 && allDataSources
                    && leaseMaintenance_schema.workorder.schema.fields.map(field => (
                      <>
                        {field.type !== 'multi_field' && field.type !== 'user_dropdown' && field?.type !== 'duration' && field.id === eachfield
                      &&(
                          <PulpoField key={field.id} {...field}
                            translation={translationMap && translationMap[field.title]}
                            handleValueChange={(a, b) => this.handleAnswerChanged('answers', a, b)}
                            isRequired={requiredMap[field.id]} answer={answers[field.id]}
                            showFieldErrors={showFormErrors}
                            handleFieldErrorChanged={this.handleFieldErrorChanged}
                            allDataSources={allDataSources}
                            type={(field.type === 'dataSource' && field.dataSourceID === 'ds10') ? 'wildlife_species' : field.type}
                            onlyTime={field.type === 'time'}
                            noDefault={field?.default !== true}
                            allFields={leaseMaintenance_schema?.workorder?.schema?.fields}
                            answers={Object.assign({}, answers, info)}
                          />
                        )
                      }
                        {field.type === 'multi_field' && field.id === eachfield && (
                        <MultiColumnGrid
                          currentField={field}
                          handleAnswerChanged={(a, b) => this.handleAnswerChanged('answers', a, b)}
                          answers={answers}
                          all_fields={leaseMaintenance_schema?.workorder?.schema?.fields}
                          showFormErrors={showFormErrors}
                          errorListMCG={errorListMCG}
                          handleFieldErrorChanged={this.handleFieldErrorChanged}
                        />)}
                        {field.type === 'duration' && field.id === eachfield && (
                          <PulpoField
                            key={field.id}
                            {...field}
                            translation={translationMap && translationMap[field.title]}
                            handleValueChange={(a, b) => this.handleAnswerChanged('answers', a, b)}
                            isRequired={requiredMap[field.id]}
                            answer={answers[field.id]}
                            showFieldErrors={showFormErrors}
                            handleFieldErrorChanged={this.handleFieldErrorChanged}
                            type={field.type}
                            answers={Object.assign({}, answers, info)}
                          />
                        )}
                      </>
                    ))}
              </>
              ))}
            </div>
          <div className={`${WorkorderStyles.footer} ${WorkorderStyles.embedded}`}>
            <Button onClick={this.cancelWorkorderCreate} translationID="maintenance.new.cancel"
              defaultText="Cancel" action="secondary"
            />
            <Button
              onClick={this.create}
              translationID="maintenance.start.title"
              defaultText="Create"
              action="secondary"
            />
          </div>
        </Panel>
      </div>
    </>
    );
  }
}

MaintenanceCreate.propTypes = {
  history: PropTypes.shape({}).isRequired,
  // actionSearchUser: PropTypes.func.isRequired,
  actionFetchCategories: PropTypes.func.isRequired,
  actionCreate: PropTypes.func.isRequired,
  actionClear: PropTypes.func.isRequired,
  userlist: PropTypes.arrayOf(PropTypes.shape({})),
  leaseMaintenance_schema: PropTypes.arrayOf(PropTypes.shape({}))
};

MaintenanceCreate.defaultProps = {
  userlist: [],
  leaseMaintenance_schema: {}
};
const mapStateToProps = state => ({
  user: state.auth.profile,
  userlist: state.inspection.userlist,
  translations: state.auth.translations,
  allCategories: state.lease.allCategories,
  locations: state.lease.locations,
  leaseMaintenance_schema: state.lease.leaseMaintenance_schema,
  allDataSources: state.inspection.allDataSources,
  createWorkorderAction: state.lease.createWorkorderAction,
  allProperties: state.lease.allProperties,
  fetchSchemaAction: state.lease.fetchSchemaAction
});

const mapDispatchToProps = dispatch => ({
  actionSearchUser: (query) => {
    dispatch(searchUser(query));
  },
  actionFetchCategories: () => {
    dispatch(fetchCategories());
  },
  actionFetchSchema: () => {
    dispatch(fetchWorkOrderSchema());
  },
  fetchDataSources: () => {
    dispatch(fetchDataSourceList());
  },
  actionCreate: (data) => {
    dispatch(createLeaseWokrorder(data));
  },
  actionfetchLocations: () => {
    dispatch(fetchLocations(true));
  },
  actionClear: () => {
    dispatch(clear());
  },
  actionFetchProfile: () => {
    dispatch(fetchUserProfile());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceCreate);
